import React from 'react';

export default function GroupManager({ show, selectedTest, subjectGroups, subjects, onAddGroup, onEditGroup, onDeleteGroup, onGroupClick }) {
  if (!show || !selectedTest) return null;

  return (
    <div className="mb-6">
      {subjectGroups && subjectGroups.length === 0 && <div className="text-sm text-gray-600">No groups created for this test yet.</div>}
      <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
        {subjectGroups?.map((group) => (
          <div
            key={group.id}
            className="p-4 bg-white rounded-lg shadow hover:shadow-lg transition cursor-pointer"
            onClick={() => onGroupClick?.(group)}
            onKeyDown={(e) => (e.key === 'Enter' || e.key === ' ') && onGroupClick?.(group)}
            role="button"
            tabIndex={0}
            aria-label={`Open questions for group ${group.name}`}
          >
            <div className="flex items-start justify-between gap-4">
              <div>
                <div className="font-medium text-indigo-700">{group.name}</div>
                <div className="text-sm text-gray-600">
                  {group.subjects?.length ? group.subjects.map((s) => s.name).join(', ') : <span className="italic text-gray-400">No subjects assigned</span>}
                </div>
              </div>
              <div className="flex flex-col gap-2">
                <button className="text-blue-500 hover:text-blue-700 text-sm" onClick={(e) => { e.stopPropagation(); onEditGroup(group); }}>
                  Edit
                </button>
                <button className="text-red-500 hover:text-red-700 text-sm" onClick={(e) => { e.stopPropagation(); onDeleteGroup(group.id); }}>
                  Delete
                </button>
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
